import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
  NavLink,
  browserHistory,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import GetStarted from "./pages/GetStarted";
import Payments from "./pages/Payments";
import Balances from "./pages/Balances";
import Invoices from "./pages/Invoices";
import Checkouts from "./pages/Checkouts";
import NewCheckouts from "./pages/NewCheckouts";
import NotFound from "./pages/NotFound";
import PointOfSale from "./pages/PointOfSale";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Otp from "./pages/Otp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import BasicVerification from "./pages/BasicVerification";
import CryptoAddress from "./pages/CryptoAddress";
import MerchantTransactions from "./pages/MerchantTransactions";
import EmailBilling from "./pages/Emailbilling";
import NewEmailbilling from "./pages/NewEmailbilling";
import PaymentButtons from "./pages/PaymentButtons";
import RecurringPaymentRequest from "./pages/RecurringPaymentRequest";
import RecurringPaymentList from "./pages/RecurringPaymentList";
import HostedCatalog from "./pages/HostedCatalog";
import HostedCatalogItem from "./pages/HostedCatalogItem";
import EditHostedCatalogItem from "./pages/EditHostedCatalogItem";
import EditEmailbilling from "./pages/EditEmailbilling";
import Settings from "./pages/Settings";
import Insights from "./pages/Insights";
// import InsightsNew from "./pages/InsightsNew.jsx";

import UserAction from "./pages/UserAction";
import ProtectedRoute from "./utils/ProtectedRoute.jsx";
import Terms from "./pages/Terms.jsx";
import Privacy from "./pages/Privacy.jsx";
import UserManagement from "./pages/UserManagement.jsx";
import Session from "./pages/Session.jsx";
import "@fortawesome/fontawesome-free/css/all.min.css";
import SettingsAPi from "./pages/Settings_api.jsx";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { SITENAMEALIAS } from "./utils/init.js";
import { getAuthToken } from "./utils/service";
import { updateFavicon } from "./utils/favicon.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import KycCapturePhoto from "./pages/KycCapturePhoto";
import IdentityVerification from "./pages/IdentityVerification";
import AutoLogin from "./pages/AutoLogin";
import ApiKeys from "./pages/ApiKeys.jsx";
import BankDetails from "./pages/BankDetails.jsx";
import UserSettings from "./pages/UserSetting.jsx";
import BussinessSettings from "./pages/BussinessSettings.jsx";
import Profile from "./pages/Profile.jsx";
import Analytics from "./pages/Analytics.jsx";
import Cart from "./pages/Cart.js";
import RefundAddress from "./pages/RefundAddress.jsx";
import CheckoutPaymentOptions from "./pages/CheckoutPaymentOptions.jsx";
import DefaultFailure from "./pages/DefaultFailure.jsx";
import DefaultSuccess from "./pages/DefaultSuccess.jsx";
import MyCartProducts from "./pages/MyCartProducts.jsx";
import ExternalWalletPaymentSuccess from "./pages/ExternalWalletPaymentSuccess.jsx";
import ProductCatalog from "./pages/ProductCatalog.jsx";
import ShippingHandling from "./pages/ShippingHandling.jsx";
import BuyerInformation from "./pages/BuyerInformation.jsx";
import Billing from "./pages/Billing.jsx";
import DiscountingProfile from "./pages/DiscountingProfile.jsx";
import CreatePayment from "./pages/CreatePayment.jsx";
import ViewPayments from "./pages/ViewPayments.jsx";
import PaymentSettings from "./pages/PaymentSettings";
import Checkout from "./pages/Checkout";
import Invoice from "./pages/Invoice";
import GetStartedNew from "./pages/GetStartedNew.jsx";
import Transactions from "./pages/Transactions.jsx";
import Redirects from "./pages/Redirects.jsx";
import Limits from "./pages/Limits.jsx";
import PaymentTolerance from "./pages/PaymentTolerance.jsx";
import DomainWhitelisting from "./pages/DomainWhitelisting.jsx";
import FeesHandling from "./pages/FeesHandling.jsx";
import Webhooks from "./pages/Webhooks.jsx";
import CreateSubscription from "./pages/CreateSubscription.jsx";
import EscrowContract from "./pages/EscrowContract.jsx";
import EscrowContractDetails from "./pages/EscrowContractDetails.jsx";
import EscrowContractCreate from "./pages/EscrowContractCreate.jsx";
import EscrowContractFund from "./pages/EscrowContractFund.jsx";
import EscrowContractDispute from "./pages/EscrowContractDispute.jsx";
import EscrowFundedContracts from "./pages/EscrowFundedContracts.jsx";

import AutomateWithdrawals from "./pages/AutomateWithdrawals";
import Rewards from "./pages/Rewards";
import CreateCampaign from "./pages/CreateCampaign";
import RewardCampaigns from "./pages/RewardCampaigns";
import RewardsAnalytics from "./pages/RewardsAnalytics";
import RewardWallet from "./pages/rewardWallet.jsx";
import PaybitoEarn from "./pages/PaybitoEarn.jsx";
import DevTools from "./pages/DevTools.jsx";
import Authorize from "./pages/Authorize.jsx";
import SignedDocs from "./pages/SignedDocs.jsx";


function App() {
  const { allColors } = useSelector((state) => state);
  const token = getAuthToken();

  useEffect(() => {
    const savedTheme = localStorage.getItem(SITENAMEALIAS + "_theme") || "dark";
    document.body.setAttribute("data-theme", savedTheme);
  }, [token]);

  useEffect(() => {
    updateFavicon();
  }, []);

  console.log("allColors in App.js", allColors);
  return (
    <div className="">
      <Router basename={process.env.PUBLIC_URL}>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/login" component={Login} />
          <ProtectedRoute exact path="/authorize" component={Authorize} />
          <ProtectedRoute
            exact
            path="/sandbox/authorize"
            component={(props) => <Authorize {...props} isSandbox={1} />}
          />
          <Route path="/signup" component={Signup} />
          <Route path="/autologin" component={AutoLogin} />
          <Route path="/signup/:param1" component={Signup} />
          <Route path="/otp" component={Otp} />
          <Route path="/signup" component={Signup} />
          <Route path="/user-action/:param1/:param2" component={UserAction} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route
            path="/reset-password/:param1/:param2"
            component={ResetPassword}
          />
          <Route path="/terms-condition" component={Terms} />
          <Route path="/privacy-policy" component={Privacy} />
          <Route
            path="/kyc-capture-photo/:param1/:param2"
            component={KycCapturePhoto}
          />
          <Route path="/cart" component={Cart} />
          <Route
            path="/merchant/checkout/payments"
            component={CheckoutPaymentOptions}
          />

          <Route
            path="/merchant/checkout/reward-wallet"
            component={RewardWallet}
          />

          <Route path="/merchant/checkout/success" component={DefaultSuccess} />
          <Route path="/merchant/checkout/failure" component={DefaultFailure} />
          <Route
            path="/merchant/external-wallet-success"
            component={ExternalWalletPaymentSuccess}
          />
          <Route path="/refund-address/:token" component={RefundAddress} />
          <Route
            path="/onboarding-processor/signed-docs/:processor/:token/:uuid"
            component={SignedDocs}
          />
          <ProtectedRoute
            path="/merchant-transactions/:param1"
            component={MerchantTransactions}
          />
          <ProtectedRoute path="/wallet" component={Dashboard} />
          <ProtectedRoute path="/dashboard" component={Analytics} />
          {/* <ProtectedRoute path="/get-started" component={GetStarted} /> */}
          <ProtectedRoute path="/get-started" component={GetStartedNew} />

          <ProtectedRoute path="/balances" component={Balances} />
          <ProtectedRoute
            path="/automate-withdrawls"
            component={AutomateWithdrawals}
          />
          <ProtectedRoute path="/payments" component={Payments} />
          <ProtectedRoute path="/checkouts" component={Checkouts} />
          <ProtectedRoute path="/bank-info" component={BankDetails} />
          <ProtectedRoute path="/my-cart-products" component={MyCartProducts} />

          <ProtectedRoute
            path="/create-new-checkout"
            component={NewCheckouts}
          />
          <ProtectedRoute path="/invoices" component={Invoices} />
          <ProtectedRoute path="/point-of-sale" component={PointOfSale} />
          <ProtectedRoute
            path="/basic-verification"
            component={BasicVerification}
          />
          <ProtectedRoute path="/crypto-address" component={CryptoAddress} />
          <ProtectedRoute path="/email-billing" component={EmailBilling} />
          <ProtectedRoute path="/payment-button" component={PaymentButtons} />
          <ProtectedRoute
            path="/request-recurring-payment"
            component={RecurringPaymentRequest}
          />
          <ProtectedRoute
            path="/recurring-payment-list"
            component={RecurringPaymentList}
          />
          <ProtectedRoute path="/hosted-catalog" component={HostedCatalog} />
          <ProtectedRoute
            path="/hosted-catalog-item"
            component={HostedCatalogItem}
          />
          <ProtectedRoute path="/insights" component={Insights} />
          {/* <ProtectedRoute path="/insights-new" component={InsightsNew} /> */}
          <ProtectedRoute path="/settings" component={Settings} />
          <ProtectedRoute path="/profile" component={Profile} />
          <ProtectedRoute path="/user-settings" component={UserSettings} />
          <ProtectedRoute
            path="/business-settings"
            component={BussinessSettings}
          />
          <ProtectedRoute path="/settings-api" component={SettingsAPi} />
          <ProtectedRoute path="/api-key" component={ApiKeys} />

          <ProtectedRoute
            path="/edit-hosted-catalog-item/:param1"
            component={EditHostedCatalogItem}
          />
          <ProtectedRoute
            path="/edit-email-bill/:param1"
            component={EditEmailbilling}
          />
          <ProtectedRoute
            path="/identity-verification"
            component={IdentityVerification}
          />
          <ProtectedRoute
            path="/payment-settings"
            component={PaymentSettings}
          />
          <ProtectedRoute path="/product-catalog" component={ProductCatalog} />
          <ProtectedRoute
            path="/shipping-handling"
            component={ShippingHandling}
          />
          <ProtectedRoute
            path="/buyer-information"
            component={BuyerInformation}
          />
          <ProtectedRoute path="/billing" component={Billing} />
          <ProtectedRoute
            path="/discounting-profile"
            component={DiscountingProfile}
          />
          <ProtectedRoute path="/create-payment" component={CreatePayment} />
          <ProtectedRoute path="/view-payments" component={ViewPayments} />
          <ProtectedRoute
            path="/create-subscription"
            component={CreateSubscription}
          />

          <ProtectedRoute
            exact
            path="/rewards/create"
            component={CreateCampaign}
          />
          <ProtectedRoute
            exact
            path="/rewards/edit/:id"
            component={CreateCampaign}
          />
          <ProtectedRoute
            exact
            path="/rewards/campaigns"
            component={RewardCampaigns}
          />
          <ProtectedRoute exact path="/rewards" component={Rewards} />
          <ProtectedRoute
            path="/rewards/analytics"
            component={RewardsAnalytics}
          />
          <Route path="/earn" component={PaybitoEarn} />

          <Route path="/merchant/checkout/:paymentId" component={Checkout} />
          <Route path="/merchant/checkout" component={Checkout} />
          <Route path="/merchant/guest-checkout/invoice" component={Invoice} />
          <ProtectedRoute path="/invoice/new" component={NewEmailbilling} />
          <ProtectedRoute path="/transactions" component={Transactions} />
          <ProtectedRoute path="/redirects" component={Redirects} />
          <ProtectedRoute path="/limits" component={Limits} />
          <ProtectedRoute
            path="/payment-tolerance"
            component={PaymentTolerance}
          />
          <ProtectedRoute
            path="/domain-whitelisting"
            component={DomainWhitelisting}
          />
          <ProtectedRoute path="/fees-handling" component={FeesHandling} />
          <ProtectedRoute path="/webhooks" component={Webhooks} />
          <ProtectedRoute
            exact
            path="/escrow/contract/create"
            component={EscrowContractCreate}
          />
          <ProtectedRoute
            exact
            path="/escrow/contract/create/:escrowId"
            component={EscrowContractCreate}
          />
          <ProtectedRoute
            exact
            path="/escrow/contract/fund/:contractId"
            component={EscrowContractFund}
          />
          <ProtectedRoute
            exact
            path="/escrow/:userType/contracts"
            component={EscrowContract}
          />
          <ProtectedRoute
            exact
            path="/escrow/:userType/contract/:contractId"
            component={EscrowContractDetails}
          />
          <ProtectedRoute
            exact
            path="/escrow/contract/dispute"
            component={EscrowContractDispute}
          />
          <ProtectedRoute
            exact
            path="/escrow/funded-contracts"
            component={EscrowFundedContracts}
          />
          <ProtectedRoute path="/user-management" component={UserManagement} />
          <ProtectedRoute path="/session" component={Session} />
          <ProtectedRoute path="/dev-tools" component={DevTools} />
          <ProtectedRoute path="*" component={NotFound} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
